
export class NumberSelect {

   constructor(settings) {

      let defaults = {
         onChange: function() { },
         max: 10,
         columns: 4,
         selectRange: false,
         getNumberTitle: false
      };

      this.set = Object.extend(true, defaults, settings);

      this.elMain = document.createElement('div');
      this.elMain.classList.add('number-select')
      this.elNumbers = this.elMain.createElement('div', 'numbers');

      this.selected = { from: false, to: false };

      for (let i=0; i<this.set.max; ++i) {
         let elNumber = this.elNumbers.createElement('div', 'number');
         elNumber.dataset.index = i;
         elNumber.style.gridArea = `${Math.floor(i/this.set.columns) + 1} / ${(i%this.set.columns) + 1}`;
         elNumber.innerHTML = this.set.getNumberTitle ? this.set.getNumberTitle(i) : (i+1);
         elNumber.onclick = (event) => this.onClickNumber(elNumber);
      }

   }

   setSelection(from, to) {

      if (!this.set.selectRange) to = from;

      this.elNumbers.querySelectorAll('.selection.between').forEach(item => item.remove());

      this.elNumbers.querySelectorAll('.number').forEach(item => {
         if (parseInt(item.dataset.index) === from || parseInt(item.dataset.index) === to) {
            item.classList.add('selected');
         }
         else {
            item.classList.remove('selected');
         }
      });

      this.updateStatus();
      this.set.onChange(this.getSelection());

   }

   onClickNumber(elNumber) {

      if (!this.set.selectRange) {
         this.elNumbers.querySelectorAll('.number.selected').forEach(el => el.classList.remove('selected'));
         elNumber.classList.add('selected');
      }
      else {

         if (elNumber.classList.contains('selected')) {
            elNumber.classList.remove('selected');
         }
         else {
            let selected = this.elNumbers.querySelectorAll('.number.selected');

            if (selected.length === 2) {
               let index = parseInt(elNumber.dataset.index);
               if (index+1 < this.selected.from || Math.abs((index+1)-this.selected.from) < Math.abs((index+1)-this.selected.to)) {
                  selected[0].classList.remove('selected');
               }
               else {
                  selected[1].classList.remove('selected');
               }
            }
            elNumber.classList.add('selected');
         }
      }

      this.updateStatus();
      this.set.onChange(this.getSelection());


   }

   updateStatus() {

      this.elNumbers.querySelectorAll('.selection.between').forEach(item => item.remove());

      let selections = this.elNumbers.querySelectorAll('.number.selected');

      if (selections.length === 0) {
         this.selected = { from: false, to: false };
      }
      else if (selections.length === 1) {
         let index = parseInt(selections[0].dataset.index);
         this.selected = { from: index, to: index };
      }
      else if (selections.length === 2) {
         let indexFrom = parseInt(selections[0].dataset.index);
         let indexTo   = parseInt(selections[1].dataset.index);
         this.selected = { from: indexFrom, to: indexTo };
         let elBetween = selections[0];

         while (elBetween !== selections[1]) {
            let index = parseInt(elBetween.dataset.index);
            let elSelection = this.elNumbers.createElement('div', 'selection between' + (elBetween === selections[0] ? ' first' : ''));
            elSelection.style.gridArea = `${Math.floor(index/this.set.columns)+1} / ${(index%this.set.columns)+1}`;
            elBetween = elBetween.nextSibling;
         }
      }

   }

   getSelection() {
      if (this.selected.from === false && this.selected.to === false) return false;
      return this.set.selectRange ? this.selected : this.selected.from;
   }

   getElement() {
      return this.elMain;
   }



}
